import FormattedMessage from 'I18n/components/FormattedMessage';
import { BaseHeader } from './BaseHeader';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProductPageHeader({
  pathKey,
  productType,
  title,
  subtitle
}) {
  let productPageTitle;
  if (title) {
    productPageTitle = title;
  } else {
    switch (pathKey) {
      case 'APPS':
        productPageTitle = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.breadcrumbs.apps"
        });
        break;
      case 'AGENTS':
        productPageTitle = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.breadcrumbs.agents"
        });
        break;
      default:
        productPageTitle = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.breadcrumbs.apps"
        });
        break;
    }
  }
  return /*#__PURE__*/_jsx(BaseHeader, {
    dataTestId: "product-page-header",
    pathKey: pathKey,
    productType: productType,
    title: productPageTitle,
    subtitle: subtitle
  });
}